import { useEffect, useState } from 'react'
import { useFirebolt } from '@iq-firebolt/client'

export default function useHasImageError() {
    const [invalidImage, setInvalidImage] = useState(false)
    const [frontIdError, setFrontIdError] = useState(false)
    const [backIdError, setBackIdError] = useState(false)
    const [userPhotoNotMatch, setUserPhotoNotMatch] = useState(false)
    
    const { remoteErrors } = useFirebolt()
    useEffect(() => {
			const errorMessage = remoteErrors[0]?.validationResults[0]?.message
      
			setInvalidImage(errorMessage === "invalid_image")
			setUserPhotoNotMatch(errorMessage === "user_photo_and_brazil_id_not_match")

			setFrontIdError(remoteErrors[0]?.slug === "brazil_id_image_front")
			setBackIdError(remoteErrors[0]?.slug === "brazil_id_image_back")
    }, [remoteErrors])
    
    return ({
      invalidImage,
      frontIdError,
      backIdError,
      userPhotoNotMatch
    })
}